// extracted by mini-css-extract-plugin
export var logos = "projects-module--logos--1Xbmj";
export var logoContainer = "projects-module--logoContainer--1NuDh";